export class SiteSessionService {
    static serviceCheck() {
        if (typeof Storage !== "undefined") {
            console.log("Site stroage set up successfully");
        } else {
            console.error("Site does not support web storage. Site might not work properly");
        }
    }

    static clearSessionStorage() {
        sessionStorage.clear();
    }

    static isStorageItemSet(item: StorageLabel): boolean {
        return sessionStorage.getItem(item) !== null;
    }

    static getStorageItem(item: StorageLabel): any {
        return sessionStorage.getItem(item);
    }

    static setStorageItem(item: string, itemKey: StorageLabel) {
        sessionStorage.setItem(itemKey, item);
    }

    static setAccessToken(token: string) {
        sessionStorage.setItem(StorageLabel.Token, token);
    }

    static getAccessToken(): string {
        return sessionStorage.getItem(StorageLabel.Token)!;
    }

    static hasAccessToken(): boolean {
        return SiteSessionService.isStorageItemSet(StorageLabel.Token);
    }

    static clearAccessToken() {
        sessionStorage.removeItem(StorageLabel.Token);
    }

    static removeStorageItem(item: StorageLabel) {
        sessionStorage.removeItem(item);
    }

    static setUserId(userId: string) {
        sessionStorage.setItem(StorageLabel.UserId, userId);
    }
    static getUserID(): string {
        const userId = sessionStorage.getItem(StorageLabel.UserId);
        return userId === null ? "" : userId;
    }
}

export enum StorageLabel {
    Token = "token",
    UserId = "userId",
    RefreshToken = "refreshtoken",
    Email = "email",
}
